import { GiTwoCoins } from 'react-icons/gi';
import { Styled } from '.';
import { useI18n } from 'contexts/i18n';

const RedeemBadge = () => {
  const i18n = useI18n();
  return (
    <Styled.RedeemContainer>
      <div>
        <GiTwoCoins color={'white'} />
      </div>
      <Styled.RedeemText>{i18n['ELIGIBLE FOR REDEMPTION']}</Styled.RedeemText>
    </Styled.RedeemContainer>
  );
};

export default RedeemBadge;
